<template>
    <div>

        <rkm-form
            v-if="!!data"
            ref="FormProcedimentos"
        >
            <rkm-area
                v-for="grupo in this.grupoProcedimentos"
                :key="grupo.id"
                :title="grupo.descricao"
                type="section"
                no-margin-top
            >
                <rkm-row
                    v-for="procedimento in grupo.procedimentos"
                    class="flex-nowrap"
                    :key="procedimento.id"
                >
                    <rkm-col cols="flex-grow-1">
                        
                        <rkm-form-checkbox-group v-model="model.procedimentos">
                            <rkm-form-checkbox
                                :value="procedimento.id"
                            >
                                {{ procedimento.descricao }}
                            </rkm-form-checkbox>
                        </rkm-form-checkbox-group>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-form>
    </div>
</template>

<script>

// Filters
import formats from '@/filters/formats'

// Mixins
import { repository, object } from '@/mixins'

export default {
    created() {

        this.load()
    },
    computed: {
        validations() {
    
            return {
                registroId: { required: true },
            }
        },
    },
    data: () => ({
        grupoProcedimentos: [],
        model: {
            procedimentos: [],
        },
        form: null,
    }),
    methods: {
        load() {

            this.grupoProcedimentos = this.clone(this.data.model.faturamento.grupoProcedimentos)

            var procedimentosAtivos = []

            this.grupoProcedimentos.forEach(function(grupoProcedimento) {

                grupoProcedimento.procedimentos.forEach(function(procedimento) {
                    
                    if (procedimento.faturar == 1) {
    
                        procedimentosAtivos.push(procedimento.id)
                    }
                });
            })

            this.model.procedimentos = procedimentosAtivos
        },
        async validate() {

            return true
        }
    },
    mixins: [ repository, object, formats, ],
    props: {
        data: { type: Object, required: false },
    },
    watch: {
        'model.procedimentos': function(procedimentosModel) {

            this.grupoProcedimentos.forEach(function(grupoProcedimento) {

                grupoProcedimento.procedimentos.forEach(function(procedimento) {

                    if (!procedimentosModel.find(id => procedimento.id == id)) {

                        procedimento.faturar = 0
                    } else {
                        
                        procedimento.faturar = 1
                    }
                })
            })

            this.data.model.faturamento.grupoProcedimentos = this.grupoProcedimentos
        }
    },
}
    
</script>